import { makeStyles } from '@material-ui/styles'

export const useStyles = makeStyles((theme) => ({
  tableContainer: {
    marginTop: theme.spacing(1),
    width: '100%',

    '& div': {
      WebkitOverflowScrolling: 'touch',
    },

    '& .MuiTable-root': {
      borderBottom: `1px solid ${theme.palette.divider} !important`,
      overflow: 'hidden !important',
    },
    
    // A tabela da paginação (segunda <table> gerada pelo material-table)
    // herda borderRadius '12px 12px 0 0' do MuiTable.js global.
    // Invertemos: topo reto, base arredondada.
    '& .MuiTable-root:has(.MuiTableFooter-root)': {
      borderRadius: '0 0 12px 12px !important',
      borderBottom: 'none !important',
      border: 'none !important',
    },
    
    [theme.breakpoints.down('xs')]: {
      '& .MuiToolbar-root:not(.MuiTablePagination-toolbar)': {
        flexDirection: 'column',
        alignItems: 'stretch',
        height: 'auto',
        padding: theme.spacing(1, 1),
      },
      '& .MuiToolbar-root:not(.MuiTablePagination-toolbar) > div': {
        width: '100% !important',
        paddingLeft: '0 !important',
        paddingRight: '0 !important',
      },
      '& .MuiToolbar-root:not(.MuiTablePagination-toolbar) .MuiInputBase-root': {
        width: '100% !important',
      },
    },
  },
  filterableColumnHeader: {
    "& .MuiInputLabel-root, & .MuiInputBase-input": {
      color: "white !important",
    },
  },
}))
